const booleanToText = (value: string | boolean | null | undefined) =>
  value === true || value === 'true'
    ? 'True'
    : value === false || value === 'false'
    ? 'False'
    : 'Unknown';

export default booleanToText;
